import React, { useEffect, useState, useMemo } from "react";


const weatherTranslation = {
    "Clear": "Despejado",
    "Mostly clear": "Mayormente despejado",
    "Partly cloudy": "Parcialmente nublado",
    "Mostly cloudy": "Mayormente nublado",
    "Cloudy": "Nublado",
    "Rain": "Lluvia",
    "Light rain": "Lluvia ligera",
    "Heavy rain": "Lluvia fuerte",
    "Thunderstorm": "Tormenta eléctrica",
    "Snow": "Nieve",
    "Fog": "Niebla",
};
function WeatherIcon({ baseUri, alt }) {
    const [src, setSrc] = useState(null);
    const [attempt, setAttempt] = useState(0);


    // lista de candidatos a probar (ordenada)
    const candidates = [
        uri => `${uri}=s64`,          // sufijo tipo =s64 (ya lo probaste)
        uri => `${uri}=s128`,         // otra resolución
        uri => `${uri}.png`,          // extensión png
        uri => `${uri}@2x.png`,       // variante retina
        uri => `${uri}_64.png`,       // otra convención posible
        uri => uri,                   // la original (por si acaso)
    ];

    useEffect(() => {
        if (!baseUri) return;
        setAttempt(0);
        setSrc(candidates[0](baseUri));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [baseUri]);

    // onError -> probar siguiente candidato
    function handleError() {
        const next = attempt + 1;
        if (next < candidates.length) {
            setAttempt(next);
            setSrc(candidates[next](baseUri));
        } else {
            setSrc(null); // ya no quedan candidatos
        }
    }

    // Si src es null mostramos fallback (fontawesome o svg)
    if (!src) {
        return (
            // fallback: Icono fontawesome (si ya lo usas)
            <i className="fas fa-cloud-sun" style={{ fontSize: 32 }} title={alt} />
        );
    }

    return (
        <img
            src={src}
            alt={alt || "icono clima"}
            style={{ width: 60 }}
            onError={handleError}
        />
    );
}

function ClimaCard() {
    const [weather, setWeather] = useState(null);

    const center = useMemo(() => ({ lat: -14.2318561, lng: -70.319716 }), []);
    const apiKey = "AIzaSyD5jco8jNgQL0TZQDyHj93TMk2ZFrNRcTY"

    async function fetchWeather() {
        const weatherURL = `https://weather.googleapis.com/v1/currentConditions:lookup?key=${apiKey}&location.latitude=${center.lat}&location.longitude=${center.lng}`;

        try {
            const [weatherRes, locationName] = await Promise.all([
                fetch(weatherURL).then(r => r.json()),
                fetchLocationName(center.lat, center.lng, apiKey)
            ]);
            setWeather({
                ...weatherRes,
                locationName
            });
        } catch (err) {
            console.error("Error al obtener clima:", err);
        }
    }

    async function fetchLocationName(lat, lng, apiKey) {
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

        const res = await fetch(url);
        if (!res.ok) throw new Error("Error en geocoding");

        const data = await res.json();

        return parseAddress(data.results);
    }

    function parseAddress(results) {
        const address = {
            calle: null,
            ciudad: null,
            provincia: null,
            departamento: null,
            pais: null,
            postal: null
        };

        for (const r of results) {
            for (const comp of r.address_components) {

                if (comp.types.includes("route") && !address.calle) {
                    address.calle = comp.long_name;
                }

                if (comp.types.includes("administrative_area_level_3") && !address.ciudad) {
                    address.ciudad = comp.long_name;
                }

                if (comp.types.includes("administrative_area_level_2") && !address.provincia) {
                    address.provincia = comp.long_name;
                }

                if (comp.types.includes("administrative_area_level_1") && !address.departamento) {
                    address.departamento = comp.long_name;
                }

                if (comp.types.includes("country") && !address.pais) {
                    address.pais = comp.long_name;
                }

                if (comp.types.includes("postal_code") && !address.postal) {
                    address.postal = comp.long_name;
                }
            }
        }

        return address;
    }


    useEffect(() => {
        fetchWeather();
    }, []);

    return (
        <div className="card card-primary card-outline">
            <div className="card-header">
                <h5 className="card-title m-0">Clima</h5>
            </div>

            <div className="card-body">
                {!weather ? (
                    <p>Cargando...</p>
                ) : (
                    <div className="col-lg-12 col-12">
                        <div className="small-box" style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            minHeight: 215, // ← ajusta el alto según necesites
                            position: "relative",
                            overflow: "hidden"
                        }}>
                            <div className="inner">
                                <p>{weather.locationName.departamento} / {weather.locationName.ciudad} / {weather.locationName.provincia}</p>

                                <h3>{weather.temperature.degrees}°C</h3>

                                <br />
                                <p>
                                    {weatherTranslation[weather.weatherCondition.description.text]
                                        || weather.weatherCondition.description.text}
                                </p>
                            </div>
                            <div
                                className="icon"
                                style={{
                                    position: "absolute",
                                    right: "15px",
                                    bottom: "10px",
                                    zIndex: 0,             // detrás del texto
                                    pointerEvents: "none"  // evitar clics
                                }}
                            >
                                <WeatherIcon
                                    baseUri={weather.weatherCondition.iconBaseUri}
                                    alt={weather.weatherCondition.description.text}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ClimaCard;
